import React from "react"
import styles from "./Contact.module.css"


function Contact() {
    return (
        <div className = {styles.container}> 
        <p className={styles.heading}>If you have any concerns about the game, PLEASE contact one of us FIRST.</p>
        <div className = {styles.contact}>
            <p className = {styles.header}>Ben Borgers</p>
        </div>
        <div className = {styles.contact}>
            <p className = {styles.header}>Abby Sommers</p>
        </div>
        <div className = {styles.contact}>
            <p className = {styles.header}>Kyuho Lee</p>
        </div>
        <div className = {styles.contact}>
            <p className = {styles.header}>Nico Anderberg</p>
        </div>

            
            
            
            
        </div>
    )
}

export default Contact
